module.exports = __webpack_public_path__ + "img/Premium Clover 58.6fb7c43d.jpg";